import React from "react";
import { DESTINATIONS } from "@/data/site";
import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";

export default function Destinations() {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="destinations" data-testid="destinations-section" className="py-20 md:py-28 px-5 md:px-8 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <SectionHeading
            eyebrow="Popular Destinations"
            title="Handpicked places our travelers love"
            subtitle="Explore top-rated locations we know inside out — from serene beaches to vibrant cities."
          />
          <button
            onClick={() => scrollTo("#packages")}
            data-testid="destinations-view-all"
            className="hidden md:inline-flex items-center gap-2 text-[#0B3D91] font-semibold hover:text-[#F9B233] transition-colors"
          >
            View all packages <ArrowUpRight className="w-4 h-4" />
          </button>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {DESTINATIONS.map((d, i) => (
            <Reveal key={d.name} delay={i * 60}>
              <div
                data-testid={`destination-card-${d.name.toLowerCase()}`}
                className="zoom-wrap group relative rounded-2xl overflow-hidden aspect-[3/4] cursor-pointer shadow-md card-lift"
                onClick={() => scrollTo("#packages")}
              >
                <img
                  src={d.img}
                  alt={d.name}
                  loading="lazy"
                  className="zoom-img absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
                <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-white/90 text-[10px] font-bold uppercase tracking-wider text-[#0B3D91]">
                  {d.tag}
                </span>
                <div className="absolute inset-x-0 bottom-0 p-5">
                  <h3 className="text-xl font-bold text-white tracking-tight">{d.name}</h3>
                  <p className="mt-1 text-sm text-white/85 line-clamp-2">{d.desc}</p>
                  <button
                    onClick={(e) => { e.stopPropagation(); scrollTo("#packages"); }}
                    data-testid={`destination-details-${d.name.toLowerCase()}`}
                    className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-[#F9B233] hover:text-white transition-colors"
                  >
                    View Details <ArrowUpRight className="w-3.5 h-3.5" />
                  </button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
